import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import BaseModal from '../../../../components/modals/BaseModal';
import { addClientNote } from '../../../../repository/NotesDAO';
import { useUserContext } from '../../../../context/user_context/UserContext';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';
import { useToast, ToastType } from '../../../../context/toast/ToastContext';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';

const AddNoteModal = ({ show, onHide, client }) => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const { setLoadingData } = useLoadingContext()
    const { firebaseUser } = useUserContext()
    const { showToast } = useToast()
    const { t } = useTranslation();

    const handleSubmit = async () => {
        setLoadingData(true);
        const item = {
            title: title,
            content: content,
            date: new Date()
        };
    
        try {
            const result = await addClientNote(firebaseUser.organization, client.id, item);
            if (result.success) {
                showToast(t(StringKeys.SUCCESSFULLY_ADDED_NOTE), ToastType.SUCCESS);
                resetForm();
            } else {
                showToast(t(StringKeys.FAILED_TO_ADD_NOTE), ToastType.DANGER);
            }
        } catch (error) {
            showToast(t(StringKeys.FAILED_TO_ADD_NOTE), ToastType.DANGER);
        } finally {
            setLoadingData(false);
            onHide();
        }
    };
    

    const resetForm = () => {
        setTitle("");
        setContent("");
    };

    const actions = (
        <Button onClick={handleSubmit}>{t(StringKeys.SUBMIT)}</Button>
    );

    if(!client) return

    return (
        <BaseModal
            open={show}
            onClose={() => {
                resetForm();
                onHide();
            }}
            title={t(StringKeys.ADD_NOTE)}
            actions={actions}
        >
            <TextField
                autoFocus
                margin="dense"
                id="title"
                label={t(StringKeys.TITLE)}
                type="text"
                fullWidth
                variant="outlined"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
                margin="dense"
                id="content"
                label={t(StringKeys.CONTENT)}
                rows={4}
                multiline
                type="text"
                fullWidth
                variant="outlined"
                value={content}
                onChange={(e) => setContent(e.target.value)}
            />
        </BaseModal>
    );
};

export default AddNoteModal;
